define("shared/components/shared/youtube-tos-modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "tracked-built-ins", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _trackedBuiltIns, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"tracked-built-ins",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.shouldShowModal}}
    <Shared::Guidelines
      @agreeText={{t "credentials.youtube.tos_modal.accept"}}
      @checkboxList={{this.checkboxList}}
      @declineText={{t "shared_words.cancel"}}
      @onDeclinedAction={{this.rejectTerms}}
      @onSuccessAction={{this.acceptTerms}}
      @subtitle={{t "credentials.youtube.tos_modal.subtitle"}}
      @title={{t "credentials.youtube.tos_modal.title"}}
    />
  {{/if}}
  */
  {
    "id": "uHG6QoiP",
    "block": "[[[41,[30,0,[\"shouldShowModal\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@agreeText\",\"@checkboxList\",\"@declineText\",\"@onDeclinedAction\",\"@onSuccessAction\",\"@subtitle\",\"@title\"],[[28,[37,2],[\"credentials.youtube.tos_modal.accept\"],null],[30,0,[\"checkboxList\"]],[28,[37,2],[\"shared_words.cancel\"],null],[30,0,[\"rejectTerms\"]],[30,0,[\"acceptTerms\"]],[28,[37,2],[\"credentials.youtube.tos_modal.subtitle\"],null],[28,[37,2],[\"credentials.youtube.tos_modal.title\"],null]]],null],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"shared/guidelines\",\"t\"]]",
    "moduleName": "shared/components/shared/youtube-tos-modal.hbs",
    "isStrictMode": false
  });
  let YoutubeToSModalComponent = _exports.default = (_class = class YoutubeToSModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "youtube", _descriptor, this);
      _initializerDefineProperty(this, "isChecked", _descriptor2, this);
      _defineProperty(this, "checkboxList", [new _trackedBuiltIns.TrackedObject({
        id: 'checkbox-1',
        label: 'credentials.youtube.tos_modal.accept_description',
        qaCheckbox: 'qa--youtube_tos_checkbox'
      }), new _trackedBuiltIns.TrackedObject({
        id: 'checkbox-2',
        label: 'credentials.youtube.tos_modal.scopes_description',
        qaCheckbox: 'qa--youtube_tos_checkbox_2'
      })]);
    }
    get shouldShowModal() {
      return this.youtube.showYoutubeToSModal && !this.youtube.hasAcceptedTerms;
    }
    acceptTerms() {
      this.youtube.acceptTerms();
      this.youtube.showYoutubeToSModal = false;
    }
    rejectTerms() {
      this.youtube.rejectTerms();
      this.youtube.showYoutubeToSModal = false;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "youtube", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isChecked", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "acceptTerms", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "acceptTerms"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rejectTerms", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "rejectTerms"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, YoutubeToSModalComponent);
});